export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-8">
          有任何问题、建议或合作意向，欢迎通过以下方式联系我们
        </p>
        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h3 className="text-lg font-bold text-foreground-800 mb-3">投稿与合作咨询</h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
            如果你有影片资源推荐、内容合作或商务洽谈需求，
            欢迎发送邮件至我们的官方邮箱，我们会在24小时内回复。
          </p>
          <a
            href="#contact"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            发送邮件
          </a>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-6 text-xs text-foreground-400">
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line"></i> 工作日 9:00 - 18:00
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i> 24小时内回复
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}